<template>
    <v-container fluid class="py-0">
        <v-chip-group
                class="multiline"
                column
                multiple
                v-model="filterByStatuses"
        >
            <v-chip v-for="status in statuses" filter :value="status.id" :key="status.id" :class="classByStatus(status.id)">
                {{ status.name }} {{ status.quantity }}x<br /><span class="caption">{{ status.hash_rate }}/{{ status.excepted_hash_rate }}, {{ status.percent}}%</span>
            </v-chip>
        </v-chip-group>
    </v-container>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'GridLegend',
        data: () => ({
        }),
        computed: {
            ...mapGetters('computers', {
                statuses: 'statuses',
            }),
            ...mapGetters('statuses', {
                classByStatus: 'styleClass',
            }),
            // ...mapState({
            //     updatedAt: state => state.computers.updatedAt,
            //     sortByDirection: state => state.computers.sortByDirection,
            // }),
            filterByStatuses: {
                get() {
                    return this.$store.state.computers.filterByStatuses;
                },
                set(value) {
                    this.$store.commit('computers/setFilterByStatuses', value);
                }
            },
        },
        methods: {},
        beforeDestroy() {
        },
        created() {
        }
    }
</script>


<style>
    .multiline .v-chip {
        text-align: center;
        height: auto;
    }
    .multiline .v-chip .v-chip__content {
        display: block;
    }
</style>
